// extracted by mini-css-extract-plugin
module.exports = {"error-title":"Modal_error-title__C7Kv0"};